export enum AuthPolicy {
    PTAdmin = "PTAdmin",
    PT = "PT",
    User = "User",
    Developer = "Developer",
    ExternalApi = "ExternalApi"
}
